module.exports = __webpack_public_path__ + "static/media/three.abef874b.png";